import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import ExportOrderReplicateService from './ExportOrderReplicate.service'
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../../software-dynamic-version-2/mainSection-multiple-inputs-v-2';
import DialogInput from '../../software-dynamic-version-2/popup-dialog-input-v-2';
import './ExportOrderReplicate.scss';
const ExportOrderReplicate = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};

 const [inputProps, setInputProps] = useState({
    CustomerOrderNo:{
      name:{id:'ExportOrderNo',value:'CustomerOrderNo'},
      caption: 'Select Export Order No',
      value: {id: undefined ,value:''},
      dataSource: {type:'Route',route:'ExportOrder'},
  },
  Replicate:{name: 'Replicate',   value: '' , enabled:true}

    });
// EXTRA CODE START
const dialogRef = useRef(null);
const showDialog = (header,title,actions =['OK']) => {
  return new Promise((resolve) => {
  // Destroy existing dialog if any
  if (dialogRef.current) {
    dialogRef.current.destroy();
  }
  const okButtons = actions.map((action) => ({
    buttonModel: {
      content: action,
      cssClass: 'e-flat',
      isPrimary: action === 'OK',
    },
    click: (e) => {
      hideDialog();
      resolve(action);
    },
  }));
  // Create a new dialog instance
  dialogRef.current = new DialogInput({
    content: ()=>(<>{title}</>),
    header:header,
    width:'340px',
    showButtons: true,
    buttons:okButtons
  });
  // Show the dialog programmatically
  dialogRef.current.show();

});

};
const hideDialog = () =>{
if (dialogRef.current) {
}
dialogRef.current.hide();
dialogRef.current.destroy();
dialogRef.current = null; // Clean up reference after destruction
}

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {

    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleOnClicked = async  ( name) => {
    console.log(name);
    
    if(name == 'Replicate'){
        if(inputProps.CustomerOrderNo.value.id == undefined){
            showDialog('WARNING' , 'PLEASE SELECT EXPORT ORDER NO!');
            setInputProps((prevValues) => ({
                ...prevValues,
                ['Replicate'] : {...prevValues['Replicate'] ,enabled:true },
              }))
        }else{
            ExportOrderReplicateService.replicate(inputProps.CustomerOrderNo.value.id).then((response)=>{
                showDialog('ALERT' , 'Replication Complete');
                setInputProps((prevValues) => ({
                    ...prevValues,
                    ['Replicate'] : {...prevValues['Replicate'] ,enabled:true },
                    ['CustomerOrderNo'] : {...prevValues['CustomerOrderNo'] ,value:{id:undefined,value:''}},
                  }))
            }).catch((e) => {
                console.log(e);
                showDialog('WARNING' , 'Replication Unsuccessful. Please contact Administrator');

              });
        }
    }
  };
 
  let inputsList = [
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    {Input: DropdownComponent,Props: {...inputProps.CustomerOrderNo, setInputProps  },ColumnSize:6},
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},
    {Input: ButtonComponent,Props: {...inputProps.Replicate,setInputProps, onClick:handleOnClicked },ColumnSize:6},
    { Input:  HiddenComponent,Props: {name:'spaceCreate',setInputProps },ColumnSize: 3},

    ];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}  className='content-wrapper' style={{padding:'15px'}}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Export Order - Replicate`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default ExportOrderReplicate;
